export { default as NDynamicTags, dynamicTagsProps } from './src/DynamicTags';
